(function () {
    // Create a service to handle Google authentication
    SUGApp.service('googleService', ['$q', function ($q) {
        var service = {
            googleConnected: false,
            scriptLoaded: false
        };
        var setGoogleConnected = function (connected) {
            service.googleConnected = connected ? true : false;
        };
        setGoogleConnected(false);

        const clientId = window.globalcfg.googleClientid;

        const loadGoogleScript = function (callback) {
            // Load Google script if not loaded
            if (window.google && window.google.accounts && window.google.accounts.id) {
                callback();
            } else if (!service.scriptLoaded || (!window.google && !window.google.accounts && !window.google.accounts.id)) {
                var script = document.createElement('script');
                script.src = 'https://accounts.google.com/gsi/client';
                script.async = true;
                script.defer = true;
                script.onload = function() {
                    service.scriptLoaded = true;
                    callback();
                };
                document.head.appendChild(script);
            } else {
                setTimeout(function () { loadGoogleScript(callback); }, 50);
            }
        };

        // Handle Google login
        service.googleLogin = function(elementId) {
            var deferred = $q.defer();
            
            loadGoogleScript(function () {
                if (!service.googleConnected) {
                    window.google.accounts.id.initialize({
                        client_id: clientId,
                        callback: function (response) {
                            // This is where you get the token!
                            deferred.resolve(response);
                        },
                        ux_mode: 'popup',
                        use_fedcm_for_prompt: true,
                        auto_select: false,
                        itp_support: true,
                    });
                    setGoogleConnected(true);
                }
                window.google.accounts.id.prompt();

                // Render the button (optional, if you want to show it)
                window.google.accounts.id.renderButton(
                    document.getElementById(elementId),
                    { theme: 'outline', size: 'large', width: '100%' }
                );
            });
            
            return deferred.promise;
        };

        return service;
    }]);
})();